// extracted by mini-css-extract-plugin
module.exports = {"modal":"tX","closeBtn":"tY","header":"tZ"};